var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container"},[_c('ag-grid-vue',{class:_vm.theme,staticStyle:{"width":"100%","height":"40vh"},attrs:{"gridOptions":_vm.gridOptions,"defaultColDef":_vm.defaultColDef,"rowData":[],"getRowId":_vm.getRowId,"overlayLoadingTemplate":_vm.overlayLoadingTemplate,"enableCellChangeFlash":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }